import { ChartGantt } from 'lucide-react';
import { BoxProps } from '@mantine/core';
import { IconWrapper } from './IconWrapper';

interface StackedLineChartIconProps extends BoxProps {
    size?: number;
    color?: string;
}

export const StackedLineChartIcon: React.FC<StackedLineChartIconProps> = ({ size = 32, color, ...props }) => {
    return (
        <IconWrapper size={size} {...props}>
            <ChartGantt size={size} color={color} />
        </IconWrapper>
    );
};
